import { Box, Typography } from "@mui/material";

/**
 * Social contribution tooltip - shows breakdown of social actions
 * @param {Object} props
 * @param {string} props.label - Brand name
 * @param {number} props.value - Total social actions
 * @param {number} props.percentage - Percentage of total
 * @param {Object} props.item - Full data item with social breakdown
 * @returns {import("react").ReactElement}
 */
export default function SocialActionsTooltip(props) {
  const { label, value, percentage, item } = props;

  // Get breakdown from item, filter out items without labels
  const breakdown = (item.breakdown || []).filter((action) => action.label);
  const datePretty = item.datePretty;

  if (breakdown.length > 0) {
    return (
      <Box sx={{ p: 0.5, minWidth: 200 }}>
        {datePretty && <Typography variant="body2">{datePretty}</Typography>}
        <Typography sx={{ fontWeight: 700, mb: 1 }}>{label}</Typography>
        {breakdown.map((action, idx) => (
          <Box key={idx} sx={{ display: "flex", justifyContent: "space-between", mb: 0.25 }}>
            <Typography>{action.label}</Typography>
            <Typography sx={{ fontWeight: 500, ml: 2 }}>
              {action.valuePretty || action.value?.toLocaleString()}
            </Typography>
          </Box>
        ))}
      </Box>
    );
  }

  // Default tooltip if no breakdown data
  return (
    <Box sx={{ p: 0.5 }}>
      <Typography sx={{ fontWeight: 600 }}>{label}</Typography>
      <Typography>
        {value?.toLocaleString()} social actions ({percentage}%)
      </Typography>
    </Box>
  );
}
